import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    borderRadius: '8px',
    '& .MuiFormControl-marginDense': {
      marginTop: '0 !important'
    },
  },
  focusedLabel: {
    color: theme.palette.mode === 'light' ? '#1A84FF' : '#046AE0'
  },
  inputLabel: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontFamily: 'Inter, sans-serif',
    fontSize: '.875rem'
  },
  inputDescription: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_500.main
        : theme.palette.gray_400.main,
    fontFamily: 'Inter, sans-serif',
    fontSize: '.75rem'
  },
  inputField: {
    borderRadius: '8px',
    '& .Mui-disabled': {
      opacity: 0.8
    },
    '& .MuiFormHelperText-root': {
      marginLeft: 0
    },

    '& .MuiOutlinedInput-adornedStart': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.white_100.main,
      '& svg': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main
      }
    },
    '& .MuiOutlinedInput-adornedEnd': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.white_100.main
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '& input[type="date"]': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main,
        backgroundColor:
          theme.palette.type === 'dark'
            ? theme.palette.dark_400.main
            : theme.palette.gray_50.main,
        padding: '4px 8px',
        borderRadius: '8px',
        '&::-webkit-calendar-picker-indicator': {
          filter: theme.palette.type === 'dark' ? 'invert(1)' : 'none',
          cursor: 'pointer',
          opacity: 0.6,
          padding: '4px',

          '&:hover': {
            opacity: 1
          }
        },
        '&::-webkit-datetime-edit-fields-wrapper': {
          color:
            theme.palette.type === 'dark'
              ? theme.palette.dark_50.main
              : theme.palette.gray_400.main
        }
      },
      '& input[type="time"]': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main,
        backgroundColor:
          theme.palette.type === 'dark'
            ? theme.palette.dark_400.main
            : theme.palette.gray_50.main,
        padding: '4px 8px',
        borderRadius: '8px',
        '&::-webkit-calendar-picker-indicator': {
          filter: theme.palette.type === 'dark' ? 'invert(1)' : 'none',
          cursor: 'pointer',
          opacity: 0.6,
          padding: '4px',

          '&:hover': {
            opacity: 1
          }
        },
        '&::-webkit-time-picker-indicator': {
          filter: theme.palette.type === 'dark' ? 'invert(1)' : 'none',
          cursor: 'pointer',
          opacity: 0.6,
          padding: '4px',

          '&:hover': {
            opacity: 1
          }
        },
        '&::-webkit-datetime-edit-fields-wrapper': {
          color:
            theme.palette.type === 'dark'
              ? theme.palette.dark_50.main
              : theme.palette.gray_400.main
        }
      }
    },

    '& input': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      padding: '4px 8px',
      borderRadius: '8px'
    },
    '& textarea': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
      // backgroundColor: theme.palette.gray_50.main
    },
    '& input[type="number"]': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      padding: '4px 8px',

      // Estilos para REMOVER as setas
      '&::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '-moz-appearance': 'textfield'
    }
  },
  dateField: {
    '& .MuiInputBase-root': {
      height: '25px'
    }
  },

  inputSuffix: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.9rem',
    paddingRight: '0px',
    userSelect: 'none' // Evita que o usuário selecione o "MB" ao tentar copiar o número
  }
}))
